import Image from "next/image";

import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";

import Heading from "sections/nfcTagsPage/Heading";
import ContactForm from "sections/nfcTagsPage/ContactForm";

import styles from "./styles";

interface ContactSectionProps {
  boxProps?: BoxProps;
}

const ContactSection: FC<ContactSectionProps> = ({ boxProps }) => {
  return (
    <Box component="section" display="grid" {...boxProps}>
      <Box sx={styles.imageWrapper}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/contact/clothes.png`}
          width={1475}
          height={599}
          alt=""
          style={{
            width: "100%",
            objectFit: "contain",
            height: "auto",
          }}
        />
      </Box>

      <Heading
        heading="Start your NFC journey!"
        subheading="Get NFC tags for your products now! Fill out the contact form with your request and our team will contact you as soon as possible. Once you receive your personalized NFC tags, simply attach them to your products and watch as they come to life with a new digital layer that enhances the customer experience. If you've ever dreamed of digitalizing your products, now is the time to make it happen. Try it out today and see the magic unfold before your eyes."
      />

      <ContactForm />
    </Box>
  );
};

export default ContactSection;
